import React from "react"
import FormAccountingRule from "./Form"

export default function CreateAccountingRule() {
  return <FormAccountingRule />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/Create.js